module.exports = __webpack_public_path__ + "img/partner_wibo_pic.c532009a.jpg";